











































import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop, Watch } from 'vue-property-decorator';
import DemographicQuestionsPopup from '@/components/user_questions/DemographicQuestionsPopup.vue';
import store from '@/store/store'
import { APIBaseURL, IsProductionEnvironment, ActiveEnvironmentName, ProjectsBaseURL, EmbedBaseURL } from './constants/environment';
import ProjectServer from './models/ProjectServer';

@Component({
	components: {
		DemographicQuestionsPopup
	}
})
export default class App extends Vue 
{
	touchMove(ev : TouchEvent)
	{
		if (ev.touches.length > 1)
		{
			ev.preventDefault();
		}
	}

	get isLTI()
	{
		return store.state.isLTI;
	}

	beforeUnloadCallback(e: BeforeUnloadEvent)
	{
		if (ProjectServer.instance)
		{
			localStorage.setItem('refresh-target', (this.$store.state as any).project.project.id);
			return 'Are you sure you want to leave? Your work will be saved, but this will close your connection to the project.';
		}
		else
		{
			localStorage.removeItem('refresh-target');
		}
		return false;
	}

	mounted()
	{
		if (!IsProductionEnvironment)
		{
			const create = this.$createElement;
			const vNodesMsg = create('p', [
				`You are running ClioVis in the environment "${ActiveEnvironmentName}" with the following base URLs:`,
				create('br'),
				create('br'),
				`API: ${APIBaseURL}`,
				create('br'),
				`Projects: ${ProjectsBaseURL}`,
				create('br'),
				`Embed: ${EmbedBaseURL}`
			]);

			this.$root.$bvToast.toast(vNodesMsg,
			{
                title: 'Environment Notification',
                variant: 'primary',
                autoHideDelay: 10000
            });
		}

		window.addEventListener('beforeunload', this.beforeUnloadCallback);
		const refreshTarget = localStorage.getItem('refresh-target');
		if (refreshTarget)
        {
			for(const nav of performance.getEntriesByType("navigation"))
			{
				if ((nav as PerformanceNavigationTiming).type === 'reload')
				{
					this.$router.push(`/app/reconnect/${refreshTarget}/4`);
					break;
				}
			}
			localStorage.removeItem('refresh-target');
		}
	}

	beforeDestroy()
	{
		window.removeEventListener('beforeunload', this.beforeUnloadCallback);
	}
}
